import React from 'react'
import { PublicationUrl } from 'src/core/models'
import styles from './PublicationUrlLanguagesColumn.module.scss'
import { languages } from 'src/core/helpers'
import Image from 'next/image'

const PublicationUrlLanguagesColumn: React.FC<{ urls: PublicationUrl[] }> = ({ urls }) => {
  const flags = urls.map(url => languages.find(l => l.value === url.language)?.src)
  return (
    <div className={styles.content}>
      {flags.map((image, idx) => (
        <Image
          key={idx}
          src={image}
          alt={`Image ${idx}`}
          width={25}
          height={25}
          objectFit='contain'
        />
      ))}
    </div>
  )
}

export default PublicationUrlLanguagesColumn
